import { render } from "./AboutView.vue?vue&type=template&id=1e1cc69c"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=1e1cc69c&lang=css"

import exportComponent from "/var/www/bip/bip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__